<section
  class="carousel"
  role="region"
  (pointerenter)="onPointerEnter($event)"
  (pointerleave)="onPointerLeave($event)"
  (focusin)="setFocusPaused(true)"
  (focusout)="setFocusPaused(false)"
>
  <div class="carousel__slider">
    <button
      *ngIf="showArrows"
      type="button"
      class="carousel__arrow carousel__arrow--previous"
      (click)="previous()"
    >
      <img src="assets/icons/carousel_arrow.svg" alt="" />
    </button>

    <div
      #list
      class="carousel__list"
      [class.carousel__list--draggable]="canPage"
      (pointerdown)="onPointerDown($event)"
      (pointerup)="onPointerUp($event)"
      (pointerleave)="onPointerUp($event)"
      (pointercancel)="onPointerUp($event)"
    >
      <div
        class="carousel__track"
        [style.--slides-to-show]="slidesToShow"
        [style.transform]="offset ? 'translateX(' + (-offset * 100) / slidesToShow + '%)' : null"
      >
        <ng-content></ng-content>
      </div>
    </div>

    <button
      *ngIf="showArrows"
      type="button"
      class="carousel__arrow carousel__arrow--next"
      (click)="next()"
    >
      <img src="assets/icons/carousel_arrow.svg" alt="" />
    </button>

    <ul *ngIf="canPage" class="carousel__dots">
      <li *ngFor="let page of pages" class="carousel__dot-item">
        <button
          type="button"
          class="carousel__dot"
          [class.carousel__dot--active]="page === currentPage"
          (click)="goTo(page)"
        ></button>
      </li>
    </ul>
  </div>
</section>
